import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import apiUrl from "../../Apiurl";
import axios from "axios";
import stilePulsanti from "../../interfaccia/stilePulsanti";
import FormCatVoce from "./FormCatVoce";
import Anteprima from "./Anteprima";
import _ from "lodash";
import ElencoMenu from "./ElencoMenu";

function CreaHtmlMenu({ variabili, utente }) {
  const menuVuoto = {
    titoloMenu: "",
    titolo: {
      it: "",
      en: "",
      fr: "",
      url: {
        it: "",
        en: "",
        fr: "",
      },
    },
    links: [],
  };

  const persone = ["unisex", "donna", "uomo", "junior"];

  const lingue = ["it", "en", "fr"];

  const datiLingua = {
    donna: {
      it: {
        prefisso: "",
        suffisso: " donna",
        parametri: "s-7/persona-donna+unisex_2",
      },
      en: {
        prefisso: "Women's ",
        suffisso: "",
        parametri: "s-7/people-woman+unisex_2",
      },
      fr: {
        prefisso: "",
        suffisso: " femme",
        parametri: "s-7/gens-femme+unisex_2",
      },
    },
    uomo: {
      it: {
        prefisso: "",
        suffisso: " uomo",
        parametri: "s-7/persona-uomo+unisex_2",
      },
      en: {
        prefisso: "Men's ",
        suffisso: "",
        parametri: "s-7/people-man+unisex_2",
      },
      fr: {
        prefisso: "",
        suffisso: " homme",
        parametri: "s-7/gens-homme+unisex_2",
      },
    },
    junior: {
      it: {
        prefisso: "",
        suffisso: " junior",
        parametri: "s-7/persona-baby+junior",
      },
      en: {
        prefisso: "Junior's ",
        suffisso: "",
        parametri: "s-7/people-baby+junior",
      },
      fr: {
        prefisso: "",
        suffisso: " enfant",
        parametri: "s-7/gens-baby+junior",
      },
    },
    unisex: {
      it: {
        prefisso: "",
        suffisso: "",
        parametri: false,
      },
      en: {
        prefisso: "",
        suffisso: "",
        parametri: false,
      },
      fr: {
        prefisso: "",
        suffisso: "",
        parametri: false,
      },
    },
  };

  const [anteprima, setAnteprima] = useState(false);
  const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [resultSalvataggio, setResultSalvataggio] = useState(false);
  const [alertSalvataggio, setAlertSalvataggio] = useState(false);
  const [salvato, setSalvato] = useState(true);
  const [menuTemp, setMenuTemp] = useState(menuVuoto);
  const [progressivoLinks, setProgressivoLinks] = useState(1);
  const [html, setHtml] = useState(false);
  const [elencoMenu, setElencoMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refresher, setRefresher] = useState(1);

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  useEffect(() => {
    let nuovoProgressivo = 1;

    if (menuTemp.links) {
      for (let i = 0; i < menuTemp.links.length; i++) {
        const id = menuTemp.links[i].idLink;
        if (id >= nuovoProgressivo) {
          nuovoProgressivo = id + 1;
        }
      }
    }

    setProgressivoLinks(nuovoProgressivo);
  }, [menuTemp]);

  function reset(e) {
    e.preventDefault();
    let sicuro = window.confirm(
      "Cancella tutti i link e i titoli di questo menu e riparti sul pulito. Sei sicuro?"
    );
    if (sicuro) {
      setMenuTemp(menuVuoto);
    }
  }

  function salvaMenu(e) {
    e.preventDefault();
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    try {
      const data = {
        menu: menuTemp,
        utente: utente.username,
        permessi: utente.permessiAPI,
      };
      const config = {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      if (!menuTemp._id) {
        //SALVA NUOVO MENU
        axios
          .post(
            apiUrl + "/manutenzione/prestashop/menu/salvaMenu",
            data,
            config
          )
          .then((resp) => {
            if (resp.data.errno) {
              setAlertSalvataggio(
                `Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`
              );
            } else {
              setAlertSalvataggio(false);
              setMenuTemp({
                ...menuTemp,
                _id: resp.data.menu._id,
              });
              setResultSalvataggio(resp.data);
              setSalvato(true);
            }
          });
      } else {
        axios
          .patch(
            apiUrl + "/manutenzione/prestashop/menu/modificaMenu",
            data,
            config
          )
          .then((resp) => {
            if (resp.data.errno) {
              setAlertSalvataggio(
                `Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`
              );
            } else {
              setAlertSalvataggio(false);
              setResultSalvataggio(resp.data);
              setSalvato(true);
            }
          });
      }
    } catch (err) {
      console.log("Errore nell'invio del prodotto alle API': " + err);
      throw err;
    }
  }

  function nuovoMenu(e) {
    e.preventDefault();
    setElencoMenu(false);
    setMenuTemp(menuVuoto);
  }

  function switchaAnteprima(e) {
    e.preventDefault();
    setAnteprima(!anteprima);
  }

  function spostaElemento(e, direzione, indice) {
    //e.preventDefault();
    setSalvato(false);
    const nuovoMenuTemp = { ...menuTemp };
    const links = [...nuovoMenuTemp.links];

    if (direzione === "avanti" && indice < links.length - 1) {
      [links[indice], links[indice + 1]] = [links[indice + 1], links[indice]];
    } else if (direzione === "indietro" && indice > 0) {
      [links[indice], links[indice - 1]] = [links[indice - 1], links[indice]];
    }

    nuovoMenuTemp.links = links;
    setMenuTemp(nuovoMenuTemp);
  }

  const handleChange = async function (evt) {
    setSalvato(false);
    const value = evt.target.value;
    try {
      if (evt.target.name.includes(".") || evt.target.name.includes("[")) {
        const update = _.set(_.cloneDeep(menuTemp), evt.target.name, value); // METODO RESOURCE EXPENSIVE
        setMenuTemp(update);
      } else if (
        !evt.target.name.includes(".") &&
        !evt.target.name.includes("[")
      ) {
        setMenuTemp({
          ...menuTemp,
          [evt.target.name]: value,
        });
      } else {
        setAlertSalvataggio("Errore cambio dato");
      }
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato nestato: " + err);
      throw err;
    }
  };

  function aggiungiLink(e) {
    e.preventDefault();
    setProgressivoLinks(progressivoLinks + 1);
    setMenuTemp({
      ...menuTemp,
      links: [
        ...menuTemp.links,
        {
          idLink: progressivoLinks,
          nomeVariabile: "",
          nomeDisplay: "",
          url: "",
        },
      ],
    });
  }

  function cancellaLink(e, idDaRimuovere) {
    e.preventDefault();
    let sicuro = window.confirm("Cancelli questa voce del menu. Sei sicuro?");
    if (sicuro) {
      const nuovaArray = menuTemp.links.filter(
        (obj) => obj.idLink !== idDaRimuovere
      );
      setMenuTemp({
        ...menuTemp,
        links: nuovaArray,
      });
    }
  }

  function generaSnippet(menu, persone, datiLingua) {
    const risultato = {};

    persone.forEach((persona) => {
      risultato[persona] = {};

      Object.keys(datiLingua[persona]).forEach((lang) => {
        if (lang !== "url") {
          const datiPersona = datiLingua[persona][lang];
          let html = "";

          menu.links.forEach((link) => {
            const { tipo, nomeLingue, url, parametri } = link;

            if (tipo === "titolo") {
              if (nomeLingue && nomeLingue[lang]) {
                html += `<p style="color: #1b5a8f; font-size: 1.125rem; font-weight: bold;" class="title-h3">${nomeLingue[lang]}</p><p></p>`;
              }
            } else if (tipo === "link") {
              //const nomeDisplay = `${datiPersona.prefisso}${nomeLingue[lang]}${datiPersona.suffisso}`;
              const nomeDisplay =
                nomeLingue && nomeLingue[lang] ? nomeLingue[lang] : "";
              let linkUrl = url && url[lang] ? url[lang] : "#";

              if (datiPersona.parametri && !parametri) {
                linkUrl += `/${datiPersona.parametri}`;
              }

              if (parametri && parametri[lang]) {
                //se ci sono parametri sovrascrivo interamente il link e poi ci aggiungo i dati della persona tranne il /s-7/
                //prestashop toglie le prime categorie quando imposti un filtro (es non mette più in url
                //la categoria padre ABBIGLIAMENTO sugli accessori quando imposti un filtro per gli accessori
                //forse perché il filtro advanced search è limitato ad accessori)
                linkUrl = `/${parametri[lang]}`;
                if (datiPersona.parametri) {
                  linkUrl += `/${datiPersona.parametri.substring(4)}`;
                }
              }

              html += `<div class="cbp-category-link-w"><a class="cbp-column-title cbp-category-title" href="${linkUrl}">${nomeDisplay}</a></div>\n\n`;
            } else if (tipo === "linea") {
              html += `<hr>\n`;
            } else if (tipo === "scritta") {
              const nomeDisplay =
                nomeLingue && nomeLingue[lang] ? `${nomeLingue[lang]}` : "";
              html += `<p class="cbp-category-link-w">${nomeDisplay}</p>\n`;
            } else if (tipo === "scrittaRossa") {
              const nomeDisplay =
                nomeLingue && nomeLingue[lang] ? `${nomeLingue[lang]}` : "";
              html += `<p style="color: #ff0000;">${nomeDisplay}</p>\n`;
            } else if (tipo === "spazio") {
              html += `<div style="margin-top:20px;"></div>\n`;
            }
          });

          risultato[persona][lang] = html;
        }
      });
    });

    return risultato;
  }

  function caricaElencoMenu() {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    try {
      setLoading(true);
      const config = {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(apiUrl + "/manutenzione/prestashop/menu/elencoMenu", config)
        .then((resp) => {
          if (resp.data.errno) {
            setAlertSalvataggio(
              `Errore nel caricamento: ${resp.data.code} - ${resp.data.message}`
            );
          } else {
            setAlertSalvataggio(false);
            setLoading(false);
            setElencoMenu(resp.data.menus);
          }
        });
    } catch (err) {
      console.log("Errore nel caricamento dei menu: " + err);
      throw err;
    }
  }

  async function caricaMenu(id) {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    try {
      setLoading(true);
      const config = {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const params = new URLSearchParams({
        id: id,
      });
      const response = await axios.get(
        apiUrl + "/manutenzione/prestashop/menu/apriMenu?" + params,
        config
      );
      setAlertSalvataggio(false);
      setLoading(false);
      setElencoMenu(false);
      setRefresher(refresher + 100);
      setMenuTemp(response.data.menu);
    } catch (error) {
      if (error.response) {
        setAlertSalvataggio(
          `Errore nel caricamento: ${error.response.status} - ${error.response.data}`
        );
        console.error(
          `Errore HTTP ${error.response.status}:`,
          error.response.data
        );
      } else {
        console.error("Errore di rete:", error.message);
      }
      throw error;
    }
  }

  function test(e) {
    console.log(variabili);
  }

  function generaHtml(e) {
    e.preventDefault();
    const htmlSnippet = generaSnippet(menuTemp, persone, datiLingua);
    setHtml(htmlSnippet);
  }

  const {
    inputClasses,
    buttonClassesWhite,
    buttonClassesOrange,
    buttonClassesRed,
    riquadroClassesRed,
    riquadroClassesGreen,
    tastoResetAspetto,
    tastoVistaAspetto,
    tastoCodiceAspetto,
    tastoCaricaAspetto,
    tastoSalvaAspetto,
    tastoFulmineAspetto,
    tastoVistaCodiceAspetto,
  } = stilePulsanti;

  ///// PAGINA

  return (
    <div className="colonnaTuttaPagina sfondoColChiaro flex flex-wrap items-start sezioneConScroll">
      {/* <h2>Creazione massiva url per nuovo menu sito</h2> */}
      {elencoMenu && (
        <div className="w-20 sfondoBiancoTema pa4 flex flex-wrap br4 ma2">
          <button className={buttonClassesWhite + " pt2"} onClick={nuovoMenu}>
            CREA NUOVO
          </button>
          <ElencoMenu
            lista={elencoMenu}
            apriElemento={caricaMenu}
            loading={loading}
          />
        </div>
      )}
      {!elencoMenu && (
        <div className="w-20 sfondoBiancoTema pa4 flex flex-wrap br4 ma2">
          <div className="w-100">
            <button className={buttonClassesRed + " pt2"} onClick={reset}>
              {tastoResetAspetto}
            </button>
            {/* <button className={buttonClassesRed + " pt2"} onClick={test}>variabili</button> */}
            {/* <button className={buttonClassesWhite + " pt2"} onClick={switchaAnteprima}>{tastoVistaCodiceAspetto}</button> */}
            {!anteprima && (
              <button
                className={buttonClassesWhite + " pt2"}
                onClick={switchaAnteprima}
              >
                {tastoVistaAspetto}
              </button>
            )}
            {anteprima && (
              <button
                className={buttonClassesWhite + " pt2"}
                onClick={switchaAnteprima}
              >
                {tastoCodiceAspetto}
              </button>
            )}
            <button
              className={buttonClassesWhite + " pt2"}
              onClick={generaHtml}
            >
              {tastoFulmineAspetto}
            </button>
            {!salvato && (
              <button
                className={buttonClassesOrange + " pt2"}
                onClick={salvaMenu}
              >
                {tastoSalvaAspetto}
              </button>
            )}
            <button
              className={buttonClassesWhite + " pt2"}
              onClick={caricaElencoMenu}
            >
              {tastoCaricaAspetto}
            </button>
            {alertSalvataggio && (
              <div className={riquadroClassesRed + " mb2"}>
                {alertSalvataggio}
              </div>
            )}
          </div>
          <div className="w-100">
            <h3 className="">titolo menu (per salvataggio)</h3>
            <input
              type="text"
              id="titoloMenu"
              name="titoloMenu"
              value={menuTemp.titoloMenu}
              onChange={handleChange}
              className={inputClasses}
            />
          </div>
          <div className="w-100 mt3">
            <div className="tc mt4">
              <div
                className="ba material-icons pa2 br-100 bordoColAlt scrittaColAlt pointer nonSelezionabile mb4 dim"
                onClick={aggiungiLink}
              >
                add
              </div>
            </div>
            {menuTemp.links.length > 0 &&
              menuTemp.links.map((link, i) => {
                return (
                  <FormCatVoce
                    key={refresher + i}
                    index={i}
                    link={link}
                    menuTemp={menuTemp}
                    setMenuTemp={setMenuTemp}
                    variabili={variabili}
                    salvato={salvato}
                    setSalvato={setSalvato}
                    cancellaLink={cancellaLink}
                    spostaElemento={spostaElemento}
                  />
                );
              })}
          </div>
          <br />
          <br />
        </div>
      )}
      <div className="w-70">
        {/* <pre className=''>{JSON.stringify(menuTemp, null, 2)}</pre> */}
        {html &&
          lingue.map((lingua, index) => {
            return (
              <div key={index} className="bb flex">
                <h1 className="w-10 ttu pr3 tc">{lingua}</h1>
                {Object.keys(html).map((persona, i) => {
                  let className = "w-30 br pb3 pr3 pl3";
                  if (i % 2 == 0) {
                    className = className + " sfondoBiancoTema";
                  }
                  return (
                    <div className={className}>
                      <h3 className="ttu tc">
                        {lingua} - {persona}
                      </h3>
                      <Anteprima
                        key={refresher + i}
                        snippet={html[persona][lingua]}
                        anteprima={anteprima}
                        i={i}
                      />
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
      {/* <div className="flex justify-center mt4">
                <div className="w-50">
                    <h3>MENU TEMP</h3>
                    <pre className=''>{JSON.stringify(variabili, null, 2)}</pre>
                </div>
            </div> */}
    </div>
  );
}

export default CreaHtmlMenu;
